import { useConfiguratorContext } from '@/kenwood/configurator/context';
import { pushStep1 } from '@/utils/Controllers/GTM/Operations/Kenwood/Configurator';
import { useEffect } from 'react';

const useSetupStep1 = () => {
  const [
    { isOwner },
    { setIsOwner, setCurrentStep },
  ] = useConfiguratorContext();
  useEffect(() => {
    setCurrentStep(1);
    // Get the u query parameter
    const urlParams = new URLSearchParams(window.location.search);
    const u = urlParams.get('u');
    let isOwnerValue = isOwner;
    if (u) {
      // Remove the u query parameter from the URL
      window.history.replaceState(
        {},
        document.title,
        `${DLG.config.encodedContextPath}/configurator/step1`,
      );

      // u parameter can be w for wannabe or o for owner
      isOwnerValue = u === 'o';
      setIsOwner(isOwnerValue);
    }
    // track gtm step1
    pushStep1(isOwnerValue);
  }, []);
};

export default useSetupStep1;
